<template>
  <div class="footer">
    <div class="warpper">
      <div class="warpper-logo">
        <img src="@/assets/imgs/logo白@3x.png" alt="" style="width: 100px;"/>
      </div>
      <div class="foot">
        <div class="fc-desc">
          <p> {{ $t('footerUbpayDesc.content') }} </p>
        </div>
      </div>
      <div class="f-nav">
        <ul>
          <li
            v-for="item in $t('footerMenu')"
            :key="item.id"
            @mouseenter="showMenu(item.id)"
            @mouseleave="() => (isShow = '')"
          >
            <a
              class="first"
              @click="() => $router.push({ name: item.url.split('-')[0] })"
              >{{ item.name }}</a
            >
            <template>
              <p v-for="el in item.childList" :key="el.id">
                <a class="second" @click="() => goThere(el.url)">{{ el.name }}</a>
              </p>
            </template>
          </li>
        </ul>
        <div class="clears"></div>
      </div>
    </div>
    <div class="backTop">
      <a @click="goTop"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      isShow: "",
    };
  },
  methods: {
    goTop() {
      let oTop = document.body.scrollTop || document.documentElement.scrollTop;
      let timer = setInterval(() => {
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          oTop -= 50;
        } else {
          clearInterval(timer);
        }
      }, 10);
    },
    showMenu(id) {
      this.isShow = id;
    },
    goThere(item) {
      this.$router.push({ name: item });
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.warpper {
  width: 1200px;
  margin: 0 auto;
  .warpper-logo {
    margin-bottom: 20px;
  }
}
.footer {
  padding: 50px 20px;
  position: relative;
  background: #3c455e;
  min-height: 386px;

  .foot {
    float: left;
    width: 500px;
    font-size: 12px;
    color: #3c455e;
    line-height: 22px;
    .fc-desc {
      text-transform: uppercase;
      font-size: 15px;
      color: #ffffff;
      line-height: 2.5em;
      margin-bottom: 10px;

      h6 {
        font-size: 30px;
        font-family: Arial;
        color: #ff9c00;
        font-weight: bold;
      }
    }
  }

  .f-nav {
    float: right;
    li {
      float: left;
      list-style: none;
      min-width: 110px;
      margin-right: 30px;
      .first {
        display: block;
        color: #ffffff;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .second {
        font-size: 13px;
        line-height: 30px;
        color: #d4d4d4;
        &:hover {
          color: #fff;
          border-bottom: 1px solid #fff;
        }
      }
    }
  }

  .backTop {
    position: absolute;
    right: 10px;
    top: 225px;

    a {
      display: block;
      width: 90px;
      height: 90px;
      background: url(../../../public/imgs/icon/top02.png) left top no-repeat;
      background-size: 100% 100% !important;

      &:hover {
        background: url(../../../public/imgs/icon/top01.png) left top no-repeat;
      }
    }
  }
}
</style>
